import axios from 'axios';
import {useAuthStore} from '@/stores/authStore.js';
import {checkToken} from "@/utils/lambdaUtils.js";
import logger from "@/utils/logger.js";

const baseUrl = import.meta.env.VITE_APP_API_BASE_URL + "/email";

// Send session termination email
export const sendSessionTerminationEmail = async (email) => {
    if (!email) {
        throw new Error('Missing required parameter: email');
    }
    if (import.meta.env.VITE_IS_DEV_LOCAL === 'true') {
        console.log("Skipping email on local environment");
        return;
    }

    const emailPayload = {
        email: email
    };

    try {
        console.log('Session Termination email api: ', emailPayload);
        await checkToken();
        const authStore = useAuthStore();
        await axios.post(baseUrl + '/logout-email', emailPayload, {
            headers: {
                'Authorization': `Bearer ${authStore.token}`,  // Include token in the header
                'Content-Type': 'application/json'  // Set content type
            }
        });
        console.log('Session Termination email sent successfully');
    } catch (emailError) {
        logger.error('Failed to send Session Termination email notification', emailError);
    }
};

// Send appeal confirmation email
export const sendAppealConfirmationEmail = async (email, appealId) => {
    if (!appealId) throw new Error('Missing required parameter: appealId');
    if (import.meta.env.VITE_IS_DEV_LOCAL === 'true') {
        console.log("Skipping appeal confirmation email on local environment");
        return;
    }

    try {
        const response = await axios.post(
            `${baseUrl}/appeal_confirmation/${appealId}`,
            { email } // Match AppealConfirmationRequest.java
        );

        return response.data;
    } catch (error) {
        logger.error(`Failed to send appeal confirmation email for appealId: ${appealId}`, error);
    }
};

// Send complaint confirmation email
export const sendComplaintConfirmationEmail = async (email, complaintId) => {
    if (!complaintId) throw new Error('Missing required parameter: complaintId');
    if (import.meta.env.VITE_IS_DEV_LOCAL === 'true') {
        console.log("Skipping complaint confirmation email on local environment");
        return;
    }

    try {
        const response = await axios.post(
            `${baseUrl}/complaint_confirmation/${complaintId}`,
            { email }  // Match ComplaintConfirmationRequest.java
        );

        return response.data;
    } catch (error) {
        console.error(`Failed to send complaint confirmation email for complaintId: ${complaintId}`, error);
        throw error;
    }
};